mtl.alloy.factory.recaptcha = (function($) {
    'use strict';

    /* globals grecaptcha */

    var isReady = false;

    var toRender = [];


    /**
     * Render a Recaptcha widget.
     */
    function render(element, options) {

        var defaults = {
            sitekey: $('script[data-recaptcha-site-key]').attr('data-recaptcha-site-key')
        };

        grecaptcha.render(element, $.extend(defaults, options));

    }


    /**
     * Callback on loading the Recaptcha library.
     */
    function onLoad() {

        isReady = true;

        for (var i = 0, ix = toRender.length; i < ix; i++) {
            var item = toRender[i];
            render(item[0], item[1]);
        }

        toRender = null;

    }


    // Attach onLoad to the window
    window.recaptchaLoaded = onLoad;


    /**
     * Return the recaptcha factory function.
     */
    return function(element, options) {

        // Ready to render
        if (isReady && window.grecaptcha) {
            render(element, options);
        }

        // Wait for library to load
        else {
            toRender.push([element, options]);
        }

    };

}(jQuery));
